/* b2s-image-text-fix.js — Force fix lumin mega image-with-text on mobile */
(function(){
  'use strict';

  function isMobile() { return window.innerWidth <= 749; }

  function applyFix() {
    /* Target the specific section */
    const sections = document.querySelectorAll('[id*="lumin_mega_3mmN6A"]');
    sections.forEach(sec => {
      if (!isMobile()) {
        /* Reset on desktop */
        const imgs = sec.querySelectorAll('img');
        imgs.forEach(img => {
          if (img.dataset.b2sFixed) {
            img.style.cssText = img.dataset.b2sOriginal || '';
            delete img.dataset.b2sFixed;
          }
        });
        return;
      }

      /* Force the grid to flex column */
      const grid = sec.querySelector('.image-with-text__grid');
      if (grid) {
        grid.style.setProperty('display', 'flex', 'important');
        grid.style.setProperty('flex-direction', 'column', 'important');
        grid.style.setProperty('flex-wrap', 'nowrap', 'important');
      }

      /* Media item: full width, taller so image isn't squashed */
      const mediaItem = sec.querySelector('.image-with-text__media-item');
      if (mediaItem) {
        mediaItem.style.setProperty('order', '1', 'important');
        mediaItem.style.setProperty('width', '100%', 'important');
        mediaItem.style.setProperty('max-width', '100%', 'important');
        mediaItem.style.setProperty('max-height', '450px', 'important');
        mediaItem.style.setProperty('height', '450px', 'important');
        mediaItem.style.setProperty('overflow', 'hidden', 'important');
        mediaItem.style.setProperty('margin', '0', 'important');
        mediaItem.style.setProperty('position', 'relative', 'important');
      }

      const media = sec.querySelector('.image-with-text__media');
      if (media) {
        media.style.setProperty('overflow', 'hidden', 'important');
        media.style.setProperty('height', '450px', 'important');
        media.style.setProperty('max-height', '450px', 'important');
        media.style.setProperty('aspect-ratio', 'auto', 'important');
        media.style.setProperty('position', 'relative', 'important');
      }

      /* IMG: contain (no crop), centered — show full carton+contents naturally */
      const img = media?.querySelector('img') || mediaItem?.querySelector('img');
      if (img) {
        img.style.setProperty('position', 'absolute', 'important');
        img.style.setProperty('inset', '0', 'important');
        img.style.setProperty('top', '0', 'important');
        img.style.setProperty('left', '0', 'important');
        img.style.setProperty('transform', 'none', 'important');
        img.style.setProperty('width', '100%', 'important');
        img.style.setProperty('height', '100%', 'important');
        img.style.setProperty('max-width', '100%', 'important');
        img.style.setProperty('max-height', '100%', 'important');
        img.style.setProperty('object-fit', 'contain', 'important');
        img.style.setProperty('object-position', 'center', 'important');
        img.style.setProperty('margin', '0', 'important');
        img.dataset.b2sFixed = '1';
      }

      /* Text item: full width, below image, with margin */
      const textItem = sec.querySelector('.image-with-text__text-item');
      if (textItem) {
        textItem.style.setProperty('order', '2', 'important');
        textItem.style.setProperty('width', '100%', 'important');
        textItem.style.setProperty('max-width', '100%', 'important');
        textItem.style.setProperty('margin-top', '24px', 'important');
        textItem.style.setProperty('padding-top', '0', 'important');
        textItem.style.setProperty('position', 'relative', 'important');
        textItem.style.setProperty('top', 'auto', 'important');
        textItem.style.setProperty('transform', 'none', 'important');
      }

      /* The inner content wrapper inside text-item */
      const textContent = textItem?.querySelector('.image-with-text__content, [class*="image-with-text__content"]');
      if (textContent) {
        textContent.style.setProperty('position', 'relative', 'important');
        textContent.style.setProperty('top', 'auto', 'important');
        textContent.style.setProperty('bottom', 'auto', 'important');
        textContent.style.setProperty('transform', 'none', 'important');
        textContent.style.setProperty('margin', '0', 'important');
        textContent.style.setProperty('padding', '20px 16px', 'important');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix);
  } else {
    applyFix();
  }
  window.addEventListener('resize', applyFix);
  const obs = new MutationObserver(() => applyFix());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
